export default {
  Title: 'Messages | Message | Messages',

  Toolbar: {
    Subtitle: 'Messages List',
    Icon    : 'email',
    Color   : 'indigo',
    Button  : {
      New: {
        Title: 'New message',
        Icon : 'add_box'
      },
      Filter: {
        Title: 'Filter by',
        Icon : 'filter_list'
      },
      Group: {
        Title: 'Group by',
        Icon : 'more_vert'
      }
    },
    Label: {
      Dear   : 'Dear',
      Sender : 'Sender',
      Reading: {
        Read  : 'Read',
        Unread: 'Unread'
      },
      Importance: {
        Important: 'Important',
        Regular  : 'Regular'
      },
      Type: 'Type'
    }
  },
  ListView: {
    Select: {
      Title   : 'Select Message',
      Subtitle: 'Select message from the list',
      Icon    : 'email'
    },
    NoData: {
      Subtitle: 'There are no messages yet.',
      Icon    : 'email'
    },
    Send: {
      Success: 'Message was send with successfully!'
    }
  },

  Template: {
    SaveSuccess        : 'Template was successfully saved!',
    DeleteSuccess      : 'Template was successfully deleted!',
    ConfirmDeleteDialog: {
      Title  : 'Delete template?',
      Content: 'Are you sure you want to delete template "<span class="font-weight-light font-italic">{title}</span>"?',
      Warning: 'Delete is final and the process is irreversible'
    }
  },

  ConfirmDeleteDialog: {
    Title  : 'Delete message?',
    Content: 'Are you sure you want to delete message "<span class="font-weight-light font-italic">{title}</span>" sent <strong>{datetime}</strong>?',
    Warning: 'Delete is final and the process is irreversible',
    Success: 'The message has been deleted successfully'
  },

  ConfirmSendWithEmailDialog: {
    Title          : 'Send message with email?',
    ContentSpecific: 'Are you sure you want to send with email message "<span class="font-weight-light font-italic">{title}</span>" sent <strong>{datetime}</strong> to the users of domains <strong>{domains}</strong>?',
    ContentAll     : 'Are you sure you want to send with email message "<span class="font-weight-light font-italic">{title}</span>" sent <strong>{datetime}</strong> to the users of <strong>all domains</strong>?'
  },

  ConfirmSendWithMessageDialog: {
    Title          : 'Send internal message?',
    ContentSpecific: 'Are you sure you want to send internal message "<span class="font-weight-light font-italic">{title}</span>" sent <strong>{datetime}</strong> to the users of domains <strong>{domains}</strong>?',
    ContentAll     : 'Are you sure you want to send internal message "<span class="font-weight-light font-italic">{title}</span>" sent <strong>{datetime}</strong> to the users of <strong>all domains</strong>?'
  },

  ConfirmSendDialog: {
    Title          : 'Send message?',
    ContentSpecific: 'Are you sure you want to send the message to the users of domains <strong>{domains}</strong>?',
    ContentAll     : 'Are you sure you want to send the message to the users of <strong>all domains</strong>?'
  },

  MessageSendDialog: {
    Toolbar: {
      Title   : '@:Message.Toolbar.Button.New.Title',
      Subtitle: 'Send new message',
      Icon    : 'email',
      Color   : 'indigo'
    },
    Field: {
      MessageType: {Label: 'Message Type'},
      Sender     : {Label: 'Sender'},
      Important  : {
        Label  : 'Important',
        IconOn : 'fas fa-exclamation-circle',
        IconOff: 'far fa-circle'
      },
      DateSent: {
        Label: 'Date to be sent',
        Icon : 'event'
      },
      ExpiredAt: {
        Label: 'Expire Date',
        Icon : 'event'
      },
      HourSent: {
        Label: 'Hour to be sent',
        Icon : 'access_time'
      },
      SentTo: {
        Label      : 'To',
        Placeholder: 'All'
      },
      MessageTitle: {
        Label      : 'Title',
        Placeholder: 'Message Title'
      }
    }
  }
}
